/* Count up when .supporting-vision enters the viewport. Repeats if you leave and return.
 * Markup: p.supporting-vision__value[data-sv-to], span.supporting-vision__num, optional data-sv-from. */

(function () {
  "use strict";

  var SECTION = ".supporting-vision";
  var VALUE = ".supporting-vision__value[data-sv-to]";
  var NUM = ".supporting-vision__num";
  var DURATION_MS = 1300;
  var STAGGER_MS = 75;
  var RESET = "0";

  var sectionState = new WeakMap();

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function wantsReduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getState(section) {
    if (!sectionState.has(section)) {
      sectionState.set(section, { cancelled: false, timeouts: [] });
    }
    return sectionState.get(section);
  }

  function clearStaggeredTimeouts(s) {
    s.timeouts.forEach(function (id) {
      clearTimeout(id);
    });
    s.timeouts = [];
  }

  function resetNumberDisplays(section) {
    section.querySelectorAll(VALUE).forEach(function (row) {
      var n = row.querySelector(NUM);
      if (n) n.textContent = RESET;
    });
  }

  function leaveSection(section) {
    var s = getState(section);
    s.cancelled = true;
    clearStaggeredTimeouts(s);
    resetNumberDisplays(section);
  }

  function animateCount(el, from, to, durationMs, state) {
    if (state.cancelled) return;
    if (durationMs <= 0 || from === to) {
      if (!state.cancelled) el.textContent = String(to);
      return;
    }
    var t0;
    function frame(now) {
      if (state.cancelled) return;
      if (t0 == null) t0 = now;
      var p = Math.min(1, (now - t0) / durationMs);
      var v = Math.round(from + (to - from) * easeOutCubic(p));
      if (p >= 1) v = to;
      el.textContent = String(v);
      if (p < 1) {
        requestAnimationFrame(frame);
      }
    }
    requestAnimationFrame(frame);
  }

  function runSection(section) {
    var rows = section.querySelectorAll(VALUE);
    if (!rows.length) return;

    var s = getState(section);
    s.cancelled = true;
    clearStaggeredTimeouts(s);
    s.cancelled = false;

    var reduced = wantsReduced();
    var duration = reduced ? 0 : DURATION_MS;
    var stagger = reduced ? 0 : STAGGER_MS;

    resetNumberDisplays(section);

    if (reduced) {
      rows.forEach(function (row) {
        if (s.cancelled) return;
        var to = parseInt(row.getAttribute("data-sv-to"), 10);
        var n = row.querySelector(NUM);
        if (n && !isNaN(to)) n.textContent = String(to);
      });
      return;
    }

    rows.forEach(function (row, i) {
      var to = parseInt(row.getAttribute("data-sv-to"), 10);
      if (isNaN(to) || to < 0) return;
      var from = parseInt(row.getAttribute("data-sv-from") || "1", 10);
      if (isNaN(from)) from = 1;
      if (from < 0) from = 0;
      if (to < from) {
        var x = from;
        from = to;
        to = x;
      }
      if (to === 0 && from === 0) return;

      var numEl = row.querySelector(NUM);
      if (!numEl) return;

      var delay = i * stagger;
      var id = setTimeout(function () {
        if (s.cancelled) return;
        numEl.textContent = String(from);
        animateCount(numEl, from, to, duration, s);
      }, delay);
      s.timeouts.push(id);
    });
  }

  function init() {
    var list = document.querySelectorAll(SECTION);
    if (!list.length) return;

    if (!("IntersectionObserver" in window)) {
      list.forEach(runSection);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            runSection(e.target);
          } else {
            leaveSection(e.target);
          }
        });
      },
      { root: null, rootMargin: "0px 0px -5% 0px", threshold: 0.12 }
    );

    list.forEach(function (section) {
      if (section.querySelector(VALUE)) io.observe(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
